import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ISMEMBER_BASE_URL} from 'ismember-api';

export interface WebPushSubscriptionData {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
  appType: 'pay88';
}

export interface WebPushSubscriptionResponse {
  message: string;
  success: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class WebPushSubscriptionService {
  constructor(
    private http: HttpClient,
    @Inject(ISMEMBER_BASE_URL) private baseUrl: string,
  ) {}

  createSubscription(
      subscriptionData: WebPushSubscriptionData,
  ): Observable<WebPushSubscriptionResponse> {
    return this.http.post<WebPushSubscriptionResponse>(
        `${this.baseUrl}/webpush/api/v0/staff/subscription`,
        subscriptionData,
    );
  }
}
